import { Answer } from './answer';
import { JsonProperty } from 'js-ts-mapper';

export class Question {
  @JsonProperty('id')
  id?: string;

  @JsonProperty('title')
  title?: string;

  @JsonProperty('personType')
  personType?: string;

  @JsonProperty('questionType')
  questionType?: string;

  @JsonProperty('questions')
  questions?: Question[];

  @JsonProperty('answer')
  answer?: Answer;

  @JsonProperty('answerses')
  answerses?: Answer[];

  answerChosen?: Answer;
}
